import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_URL}/products`;

function authHeaders(token: string) {
    return { Authorization: `Bearer ${token}` };
}

export interface Product {
    _id: string;
    name: string;
    brand: string;
    price: number;
    qty: number;
    image: string;
    category: string;
    subcategory?: string;
    application?: string;
    material?: string;
    size?: string;
    color?: string;
    description: string;
    usage?: string;
    hsnCode?: string;
    gstRate?: number;
    courierCharges?: number;
    countUnit?: string;
    weightUnit?: string;
    lengthUnit?: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface ProductListQuery {
    page?: number;
    limit?: number;
    search?: string;
    category?: string;
    isActive?: boolean;
    sortField?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface ProductListResponse {
    products: Product[];
    total: number;
    page: number;
    limit: number;
}

export interface ProductCategory {
    _id: string;
    name: string;
}

export const productService = {
    getPublicAll(query: { category?: string; page?: number; limit?: number; search?: string } = {}) {
        return axios.get<ProductListResponse & { categories: string[] }>(
            `${BASE}/public/all`,
            { params: query }
        );
    },

    getPublicById(id: string) {
        return axios.get<{ product: Product }>(`${BASE}/public/${id}`);
    },

    create(formData: FormData, token: string) {
        return axios.post<{ msg: string; product: Product }>(
            `${BASE}/upload`,
            formData,
            { headers: { ...authHeaders(token) }, withCredentials: true }
        );
    },

    getAll(query: ProductListQuery, token: string) {
        return axios.get<ProductListResponse>(
            `${BASE}/all`,
            { params: query, headers: authHeaders(token), withCredentials: true }
        );
    },

    getCategories(token: string) {
        return axios.get<{ categories: ProductCategory[] }>(
            `${BASE}/categories`,
            { headers: authHeaders(token), withCredentials: true }
        );
    },

    getById(id: string, token: string) {
        return axios.get<{ product: Product }>(
            `${BASE}/${id}`,
            { headers: authHeaders(token), withCredentials: true }
        );
    },

    update(id: string, formData: FormData, token: string) {
        return axios.put<{ msg: string; product: Product }>(
            `${BASE}/${id}`,
            formData,
            { headers: { ...authHeaders(token) }, withCredentials: true }
        );
    },

    remove(id: string, token: string) {
        return axios.delete<{ msg: string }>(
            `${BASE}/${id}`,
            { headers: authHeaders(token), withCredentials: true }
        );
    },
};
